import { Controller, useFormContext } from 'react-hook-form'

import { FF2, TextareaInput } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const Notes = () => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name="generalInfo.notes"
      control={control}
      render={({ field }) => (
        <FF2 field={field} label="Notes" input={(props) => <TextareaInput {...props} data-qa="General. Notes" />}></FF2>
      )}
    />
  )
}
